// extracted by mini-css-extract-plugin
export default {"aboutPage":"about_aboutPage__j6Z5p","aboutContainer":"about_aboutContainer__DGkk7","profileImage":"about_profileImage__2tQLa"};